/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Avatar, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Paper from '@material-ui/core/Paper';
import { Business, FindInPage, Room } from '@material-ui/icons';
import {
  getInfosDashboard,
  getNumberJobById,
  getNumberExternalJobById,
  searchSchoolsPartners,
} from '@webapps/business';
import {
  PaginationNumbers,
  useAuth,
  useQuery,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';

import theme from '../theme';

const {
  colors: { addressColor, background },
} = theme;

const Partner = () => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { params } = useRouter();
  const { id: idParam } = params;
  const { idUser, profile } = useAuth();
  const [page, setPage] = useState(1);

  const [size, setSize] = useState(window.innerWidth < 768 ? 3 : 4);

  const { data: { content: partners = [], totalElements } = {}, refetch } = useQuery(searchSchoolsPartners, {
    key: ['schoolsPartnersRequest', page, idParam || idUser],
    variables: {
      id: typeof idParam !== 'undefined' ? idParam : idUser,
      individual: profile === 'INDIVIDUAL' ? idUser : undefined,
      type: profile !== "BUSINESS" ? "all" : "internal",
      accept: true,
      page: page - 1,
      size,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const [scroll, setScroll] = useState(false);

  const handleScroll = (e) => {
    if (scroll) return;
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
    if (scrollPercentage >= 80) {
      setScroll(true);
    }
  };

  useEffect(() => {
    if (scroll) {
      if (totalElements <= size) {
        return;
      }
      setSize(size + 4);
      setTimeout(() => {
        setScroll(false);
        refetch();
      }, 200);
    }
  }
    , [scroll]);

  return (
    <div className={classes.container}>
      <div className={cx(global.title, classes.title)}>
        Nos partenaires
      </div>
      {!partners?.length ? (
        <div
          className={css({
            textAlign: 'center',
            color: '#5D75A8',
            padding: 20,
          })}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <Grid
          container
          direction="column"
          className={css({
            backgroundColor: '#F3F7FF',
            marginTop: spacing(2),
            padding: spacing(2),
            borderRadius: 10,
            maxHeight: '210px',
            '@media only screen and (max-width: 768px)': {
              height: 'auto',
              overflowX: 'hidden',
              maxHeight: 'none',
            },
          })}
        >
          <div className={css({
            flexDirection: 'row',
            display: 'flex',
            gap: 16,
            paddingRight: partners?.length > 2 ? spacing(2) : 0,
            overflowX: 'hidden',
            flexWrap: 'wrap',
            '&::-webkit-scrollbar': {
              backgroundColor: '#F3F7FF',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#0060F9',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#C0D9FF',
            },
            '@media only screen and (max-width: 768px)': { overflow: 'hidden', padding: 0 },
          })}
            onScroll={(e) => handleScroll(e)}
          >
            {partners?.map((partner) => (
              <PartnerCard partner={partner} />
            ))}
          </div>
        </Grid>
      )}
      <div className={classes.pagination}>
        <PaginationNumbers
          onChange={(newPage) => setPage(newPage)}
          page={page}
          pageCount={size}
          totalCount={totalElements}
        />
      </div>
    </div>
  );
};

const PartnerCard = ({ partner }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { profile } = useAuth();

  const { data: nbr } = useQuery(partner?.status ? getNumberExternalJobById : getNumberJobById, {
    key: ['nbrJobs', partner?.id],
    variables: { id: partner?.id },
    enabled: !!partner?.id,
  });

  const history = useHistory();

  const { data: dashboardInfo = {} } = useQuery(getInfosDashboard, {
    key: ['infoDashboardBusiness', partner?.id],
    variables: { id: partner?.id },
    enabled: !!partner?.id || !partner?.status,
  });

  const profileImage = dashboardInfo?.profile?.profileImageUrl;

  const goToMapWithSelector = () => {
    if (profile === 'INDIVIDUAL') {
      push(ROUTES_PATH.MYMAP, {
        searchParams: {
          businesses: id,
        },
        from: 'business',
      });
    } else if (profile === 'BUSINESS') {
      push(ROUTES_PATH.MAP_BUSINESS, {
        searchParams: {
          businesses: id,
        },
        from: 'business',
      });
    } else if (profile === 'SCHOOL') {
      push(ROUTES_PATH.MAP_SCHOOL, {
        searchParams: {
          businesses: id,
        },
        from: 'business',
      });
    } else if (profile === 'CFA') {
      push(ROUTES_PATH.MAP_CFA, {
        searchParams: {
          businesses: id,
        },
        from: 'business',
      });
    }
  }

  return (
    <Paper className={classes.cardContainer} elevation={0} onClick={goToMapWithSelector}>
      <div>
        <div
          className={css({
            display: 'flex',
            alignItems: 'center',
          })}
        >
          <div className={classes.photo}>
            {profileImage || partner?.profileImageUrl ? (
              <Avatar className={classes.avatar} src={profileImage || partner?.profileImageUrl} />
            ) : (
              <Avatar className={classes.avatar}>{partner?.name?.substr(0, 1)}</Avatar>
            )}
          </div>
          <Grid>
            <div className={cx(global.subTitle, classes.nameRow)}>
              <h1 className={cx(global.title, classes.titre)}> {partner?.name}
                <span className={css({ marginLeft: spacing(1) })}> {partner?.status ? null : (<VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />)} </span>
              </h1>
            </div>
            <div className={cx(global.infoText, classes.avatarRow)} >
              <Room className={global.smallIcon} />
              <p className={classes.address}>{partner?.address?.cityCode} {partner?.address?.city}</p>
            </div>
          </Grid>
        </div>
        <div className={css({
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
          gap: spacing(0.5),
          marginTop: spacing(2),
        })}>
          <div className={cx(global.infoText, classes.row)} >
            <Business className={cx(global.infoIcon, classes.labelIcon)} />
            <p className={cx(global.infoText, classes.text)}>{partner?.sector?.label}</p>
          </div>
          <Grid className={cx(global.infoText, classes.row)} >
            <FindInPage className={global.infoIcon} />
            <p className={cx(global.infoText, classes.text)}>{nbr > 0 ? `${nbr} offre${nbr > 1 ? 's' : ''} disponible` : 'Aucune offre disponible'}</p>
          </Grid>
        </div>
      </div>
    </Paper>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background,
    borderRadius: 10,
    padding: '20px',
    marginBottom: 25,
    '@media screen and (max-width: 768px)': {
      marginBottom: 20,
    },
  },
  pagination: {
    '@media screen and (min-width: 768px)': {
      display: 'none',
    }
  },
  partnerDiv: {
    display: 'flex',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  avatarRow: {
    display: 'flex',
    marginLeft: spacing(2),
    marginTop: spacing(1),
    textAlign: 'start',
    alignItems: 'center',
  },
  nameRow: {
    marginLeft: spacing(2),
    display: 'flex',
  },
  address: {
    marginTop: 0,
    marginBottom: 0,
  },
  text: {
    marginTop: 0,
    marginBottom: 0,
    // whiteSpace: 'nowrap',
    // overflow: 'hidden',
    // textOverflow: 'ellipsis',
    maxWidth: '80%',
    // "@media screen and (max-width: 768px)": {
    //   maxWidth: "400px"
    // },
    // "@media screen and (max-width: 600px)": {
    //   maxWidth: "350px"
    // },
    // "@media screen and (max-width: 500px)": {
    //   maxWidth: "300px"
    // },
    // "@media screen and (max-width: 450px)": {
    //   maxWidth: "250px"
    // },
    // "@media screen and (max-width: 400px)": {
    //   maxWidth: "200px"
    // },
    // "@media screen and (max-width: 365px)": {
    //   maxWidth: "150px"
    // },
    // "@media screen and (max-width: 300px)": {
    //   maxWidth: "100px"
    // },
  },
  labelIcon: {
    alignSelf: 'self-start'
  },
  titre: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 0,
    marginTop: 0,
  },
  title: {
    display: 'flex',
    direction: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    paddingLeft: 8,
    borderLeft: '3px solid #0060F9',
  },
  avatar: {
    height: 70,
    width: 70,
  },
  cardContainer: {
    borderRadius: 10,
    display: 'flex',
    border: '1px solid #C0D9FF',
    cursor: 'pointer',
    width: '49%',
    flexDirection: 'column',
    padding: spacing(2.5),
    height: '100%',
    transition: 'all 0.2s',
    '&:hover': {
      transition: 'all 0.2s',
      border: '1px solid #0060F9',
      'h1': {
        transition: 'all 0.2s',
        color: '#152652',
      },
      'p': {
        transition: 'all 0.2s',
        color: '#152652',
      },
      'svg': {
        transition: 'all 0.2s',
        color: '#0060F9',
      }
    },
    '@media (max-width:1520px)': { width: '48.7%' },
    '@media (max-width:1280px)': { width: '100%' },
  },
  photo: {
    display: 'flex',
    justifyContent: 'center',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
  },
});

export default Partner;
